import React, { useState, useEffect, useRef } from 'react';
import '../styles/GeolocationStatus.css';

// Ne rend que le contenu (icône position, pastille de statut, champ texte):
// le conteneur (fond neutre, disposition) vit dans App.jsx, qui y ajoute
// aussi la puce de rayon sur la même ligne.
function GeolocationStatus({ userLocation, loading, error, locationLabel, geocoding, geocodeError, onSearchAddress, onRefreshPosition }) {
  const [query, setQuery] = useState('');
  const editingRef = useRef(false);
  const lastAutoValueRef = useRef('');

  // Synchronise le champ avec la position courante (GPS ou adresse
  // recherchée), sauf pendant que l'utilisateur est en train de taper.
  useEffect(() => {
    if (editingRef.current || !userLocation) return;
    const coords = `${userLocation.latitude.toFixed(4)}, ${userLocation.longitude.toFixed(4)}`;
    const display = locationLabel || coords;
    lastAutoValueRef.current = display;
    setQuery(display);
  }, [userLocation, locationLabel]);

  const handleFocus = (e) => {
    editingRef.current = true;
    e.target.select();
  };

  const handleBlur = () => {
    editingRef.current = false;
    const trimmed = query.trim();
    if (!trimmed) {
      setQuery(lastAutoValueRef.current);
    } else if (trimmed !== lastAutoValueRef.current) {
      onSearchAddress(trimmed);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  };

  const busy = loading || geocoding;
  const statusClass = busy
    ? 'loading'
    : geocodeError
    ? 'error'
    : userLocation && userLocation.isDefault
    ? 'default'
    : 'success';
  const statusTitle = geocodeError
    ? 'Adresse introuvable, réessayez'
    : userLocation && userLocation.isDefault
    ? (error || "Votre position réelle n'a pas pu être obtenue")
    : 'Position trouvée';

  return (
    <>
      <button
        type="button"
        className="geo-pin"
        onClick={onRefreshPosition}
        disabled={busy}
        title="Utiliser ma position GPS"
        aria-label="Utiliser ma position GPS"
      >
        📍
      </button>
      {busy
        ? <span className="geo-spinner" aria-hidden="true"></span>
        : <span className={`geo-dot geo-dot--${statusClass}`} title={statusTitle}></span>}
      <input
        type="text"
        className="geo-input"
        value={query}
        placeholder="Saisir une adresse…"
        disabled={geocoding}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        enterKeyHint="search"
        title={statusTitle}
      />
    </>
  );
}

export default GeolocationStatus;
